<template>
    <CRow>
        <CCol col>
            <div class="fx-price-padding"></div>
            <ejs-datepicker ref="dateObj" :placeholder="waterMark" v-model="dateVal" :format="dateFormat" :focus='onFocus' :firstDayOfWeek='1' :max='maxVal' width=180></ejs-datepicker>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="fxData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' 
                          :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' 
                          :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' 
                          :pageSettings='pageSettings' :actionBegin='actionBegin' :actionComplete='actionComplete'
                          :actionFailure="actionFailure" :query='query' :filterSettings='filterOptions'width="100%" height="100%">
                    <e-columns>
                        <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='currencyConversionName' headerText='Conversion Identifier' textAlign='Left' width=160></e-column> 
                        <e-column field='currencyConversionId' headerText='Conversion Identifier' textAlign='Left' :visible="false" :validationRules="requiredRules" editType='dropdownedit' :edit='currencyParams' foreignKeyField="id" foreignKeyValue='code' :dataSource='currencies' width=190></e-column>
                        <e-column field='currencyConversionFrom' headerText='Currency from' textAlign='Left' :allowEditing="false" width=160></e-column>
                        <e-column field='currencyConversionTo' headerText='Currency to' textAlign='Left' :allowEditing="false" width=160></e-column>
                        <e-column field='date' headerText='Settlement Date' textAlign='Left' :validationRules="requiredRules" :format='dateFormatOptions' type='date' :edit="dpParams" width=180></e-column>
                        <e-column field='rate' headerText='Settlement Price' textAlign='Left' format='n3' :validationRules="percentageRules" editType='numericedit' :edit='numericParams' width=180></e-column>
                        <e-column field='createdBy' headerText='Created By' textAlign='Left' :allowEditing="false" width=150></e-column>
                        <e-column field='createdDate' headerText='Import Date' textAlign='Left' :allowEditing="false" :format='dateFormatOptions' type='date' width=150></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div id="modalTargetFX" class="control-section; position:relative" style="height:350px;">
                <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import urls from '../../common/urls'
    import authToken from '../../common/authToken';
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import { DatePickerPlugin, DatePicker  } from '@syncfusion/ej2-vue-calendars';
    import apis from '../../common/network'
    import store from '../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DatePickerPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(GridPlugin);

    let currencies = SyncHelper.getDataManager('Utils/currencyConversions');

    let ricObj, ricElem, datePickerObj, elem;
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                maxVal: new Date(),
                waterMark: 'Select a date',
                dateVal: dates.addDays(new Date(), -1),
                format: "dd/MM/yyyy",
                dateFormat: 'dd/MM/yyyy',
                currencies: currencies,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                dpParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {
                        datePickerObj = new DatePicker({
                            value: new Date(args.rowData[args.column.field]),
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            //sets the max. 
                            max: dates.addDays(new Date(), -1),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1
                        });
                        datePickerObj.appendTo(elem);
                    }
                },
                numericParams: {
                    params: {
                        validateDecimalOnType:true,
                        decimals: 4,
                        format: "N4"
                    },


                },
                path: {
                    saveUrl: `${urls.apiBaseUrl}FXRate/Import/`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                fxData: SyncHelper.getDataManager("FXRate"),
                currencyParams: {
                    create: () => {
                        ricElem = document.createElement('input');
                        return ricElem;
                    },
                    read: () => {
                        return ricObj.value;
                    },
                    destroy: () => {
                        ricObj.destroy();
                    },
                    write: (args) => {
                        ricObj = new DropDownList({
                            dataSource: currencies,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                apis.protectedApi(`${urls.apiBaseUrl}Utils/currencyConversions`).then(it => {
                                    var mappedCc = it.data.filter(function (cc) {
                                        return cc.id == args.value;
                                    });
                                    document.getElementsByName("currencyConversionFrom")[0].value = mappedCc[0].currencyFrom;
                                    document.getElementsByName("currencyConversionTo")[0].value = mappedCc[0].currencyTo;

                                }
                                ).catch(
                                    response => {
                                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                        gridOptions.errorAlert("Error: " + message);
                                    }
                                );
                            },
                            placeholder: 'Conversion Identifier',
                            floatLabelType: 'Always'
                        });
                        ricObj.appendTo(ricElem);
                    }
                },
                
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.LatestSettlement.Update"],
                    allowAdding: store.state.permissions["Permissions.LatestSettlement.Create"],
                    allowDeleting: store.state.permissions["Permissions.LatestSettlement.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                percentageRules: { required: true, number: true},
                requiredRules: { required: true },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            this.checkPermissionOnUser();
        },
        methods: {
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                        this.toolbar = ['Add', 'Edit', 'Delete'];
                        document.getElementById("modalTargetFX").style.display = "none";
                    }

            },
            toolbarClick(args) {
                gridOptions.excelExport(args, "FX Rates.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "createdBy") {
                          this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "createdDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }
                    }
                }
                this.$refs.grid.getColumns()[2].visible = true;//id
                this.$refs.grid.getColumns()[1].visible = false;//name
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "createdBy") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "createdDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }
                    }
                   
                }
                this.$refs.grid.getColumns()[2].visible = false;//id
                this.$refs.grid.getColumns()[1].visible = true;//name
            },
            actionFailure(args) {
                gridOptions.actionFailure(args)
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
        },
        computed: {
            query: function () {
                this.dateVal;

                return new Query().addParams("date", this.dateVal.toISOString().split('T')[0]);
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };
</script>
<style scoped>
    .fx-price-padding {
        padding-top: 30px;
    }
</style>
